// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { SummaryDocsRoutingModule } from './summary-docs-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { SummaryDocsPropertiesDialogComponent } from "src/app/modules/summary-docs/components/summary-docs-properties-dialog/summary-docs-properties-dialog.component";
import { NextInsertionsDocsListComponent } from 'src/app/modules/summary-docs/pages/next-insertions/next-insertions-list.page';
import { SummaryDocsListComponent } from 'src/app/modules/summary-docs/pages/summary-docs-list/summary-docs-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    SummaryDocsRoutingModule,
    // PublicModule,
  ],
  declarations: [
    SummaryDocsListComponent,
    SummaryDocsPropertiesDialogComponent,
    NextInsertionsDocsListComponent,
  ],
  entryComponents: [
  ],
  exports: [
    SummaryDocsPropertiesDialogComponent
  ]
})
export class SummaryDocsModule { }
